import api from "./api";

export const getEscalatedTickets = async (status, page = 1, limit = 20) => {
  const params = new URLSearchParams();
  if (status) params.append("status", status);
  params.append("page", page);
  params.append("limit", limit);
  return api.get(`/support/escalated?${params.toString()}`);
};

export const getTicketDetails = async (ticketId) => {
  return api.get(`/support/ticket/${ticketId}`);
};

export const replyToTicket = async (ticketId, message) => {
  return api.post("/support/reply", { ticketId, message });
};

export const escalateToBackOffice = async (ticketId, note) => {
  return api.post("/support/escalate-backoffice", { ticketId, note });
};

export const assignToBackOffice = async (ticketId) => {
  return api.post("/support/assign-backoffice", { ticketId });
};

export const resolveTicket = async (ticketId, resolutionNote) => {
  return api.post("/support/resolve", { ticketId, resolutionNote });
};

export const closeTicket = async (ticketId) => {
  return api.post("/support/close", { ticketId });
};
